const TimeDefault = [
  {
    id: 0,
    name: '10:00',
    value: '10:00',
  },
  {
    id: 1,
    name: '10:30',
    value: '10:30',
  },
  {
    id: 2,
    name: '11:00',
    value: '11:00',
  },
  {
    id: 3,
    name: '11:30',
    value: '11:30',
  },
  {
    id: 4,
    name: '12:00',
    value: '12:00',
  },
  {
    id: 5,
    name: '12:30',
    value: '12:30',
  },
  {
    id: 6,
    name: '13:00',
    value: '13:00',
  },
  {
    id: 7,
    name: '13:30',
    value: '13:30',
  },
  {
    id: 8,
    name: '14:00',
    value: '14:00',
  },
  {
    id: 9,
    name: '14:30',
    value: '14:30',
  },
  {
    id: 10,
    name: '15:00',
    value: '15:00',
  },
  {
    id: 11,
    name: '15:30',
    value: '15:30',
  },
  {
    id: 12,
    name: '16:00',
    value: '16:00',
  },
  {
    id: 13,
    name: '16:30',
    value: '16:30',
  },
  {
    id: 14,
    name: '17:00',
    value: '17:00',
  },
  {
    id: 15,
    name: '17:30',
    value: '17:30',
  },
  {
    id: 16,
    name: '18:00',
    value: '18:00',
  },
  {
    id: 17,
    name: '18:30',
    value: '18:30',
  },
  {
    id: 18,
    name: '19:00',
    value: '19:00',
  },
  {
    id: 19,
    name: '19:30',
    value: '19:30',
  },
  {
    id: 20,
    name: '20:00',
    value: '20:00',
  },
];

const DurationDefault = [
  {
    id: 0,
    name: '1 Jam',
    value: 60,
  },
  {
    id: 1,
    name: '1 Jam 30 Menit',
    value: 90,
  },
  {
    id: 2,
    name: '2 Jam',
    value: 120,
  },
  {
    id: 3,
    name: '2 Jam 30 Menit',
    value: 150,
  },
  {
    id: 4,
    name: '3 Jam',
    value: 180,
  },
];

const AgeDefault = [
  {
    id: 0,
    name: 'Baby',
    value: 'Baby',
    description: '(6-18 mon)',
    class: 'bg-[#908572] text-white',
  },
  {
    id: 1,
    name: 'Toddler',
    value: 'Toddler',
    description: '(1.5-3 yo)',
    class: 'bg-[#73C8AF] text-white',
  },
  {
    id: 2,
    name: 'Baby & Toddler',
    value: 'BABY_TODDLER',
    description: '(6 mon - 3 yo)',
    class: 'bg-[#86A896] text-white',
  },
  {
    id: 3,
    name: 'Kinder',
    value: 'Kinder',
    description: '(3.5-5 yo)',
    class: 'bg-[#E8BA3B] text-[#876C00]',
  },
  {
    id: 4,
    name: 'Child',
    value: 'Child',
    description: '(6-8 yo)',
    class: 'bg-[#91C5EB] text-white',
  },
  {
    id: 5,
    name: 'Tween',
    value: 'Tween',
    description: '(9-12 yo)',
    class: 'bg-[#F58136] text-white',
  },
  {
    id: 6,
    name: 'Adult',
    value: 'Adult',
    description: '(13+)',
    class: 'bg-[#C03A2B] text-white',
  },
];

const DifficultyDefault = [
  {
    id: 0,
    name: 'Sensory',
    value: 'sensory',
  },
  {
    id: 1,
    name: 'Medium',
    value: 'Medium',
  },
  {
    id: 2,
    name: 'Hard',
    value: 'Hard',
  },
];

const TypeClassDefault = [
  {
    id: 0,
    name: 'Regular Class',
    value: 'Regular',
    desc: 'Standard everyday class with any of our KIN Teachers',
    class: 'bg-[#D1D275] text-[#655C25] border border-[#655C25]',
  },
  {
    id: 1,
    name: 'Special Class',
    value: 'Special',
    desc: 'Standard classes with special teachers',
    class: 'bg-[#E0FFF6] text-[#17A085] border border-[#17A085]',
  },
  {
    id: 2,
    name: 'Curated Class',
    value: 'Curated',
    desc: 'Seasonal / Occasional Classes',
    class: 'bg-[#CEEAFF] text-[#2980B9] border border-[#2980B9]',
  },
  {
    id: 3,
    name: 'Featured Class',
    value: 'Featured',
    desc: 'Collaborative classes with special guests',
    class: 'bg-[#EDE1FF] text-[#8E44AD] border border-[#8E44AD]',
  },
  {
    id: 3,
    name: 'Private Class',
    value: 'Private',
    desc: 'Private classes booked through inquiry',
    class: 'bg-[#bfdbfe] text-[#1d4ed8] border border-[#1d4ed8]',
  },
];

const SubjectDefault = [
  {
    id: 1,
    name: 'Sensory',
    value: 'sensory',
    class: 'bg-[#D6E7FB] text-[#4752C0] border border-[#4752C0]',
  },
  {
    id: 2,
    name: 'Art & Craft',
    value: 'art & craft',
    class: 'bg-[#ECF0F1] text-[#5D6667] border border-[#5D6667]',
  },
  {
    id: 3,
    name: 'Music',
    value: 'music',
    class: 'bg-[#FFF2F2] text-[#C03A2B] border border-[#C03A2B]',
  },
  {
    id: 4,
    name: 'Wellness',
    value: 'wellness',
    class: 'bg-[#FFD3B7] text-[#D35400] border border-[#D35400]',
  },
  {
    id: 5,
    name: 'Cookery',
    value: 'cookery',
    class: 'bg-[#EFFFEE] text-[#26BC00] border border-[#26BC00]',
  },
];

const PeriodDefault = [
  {
    id: 0,
    name: 'Everyday',
    value: 'everyday',
  },
  {
    id: 1,
    name: 'Weekday',
    value: 'weekday',
  },
  {
    id: 2,
    name: 'Weekend',
    value: 'weekend',
  },
  {
    id: 3,
    name: '1 Month',
    value: '1 month',
  },
  {
    id: 4,
    name: '2 Month',
    value: '2 month',
  },
  {
    id: 5,
    name: '3 Month',
    value: '3 month',
  },
  {
    id: 6,
    name: '4 Month',
    value: '4 month',
  },
  {
    id: 7,
    name: '5 Month',
    value: '5 month',
  },
  {
    id: 8,
    name: '6 Month',
    value: '6 month',
  },
  {
    id: 9,
    name: '7 Month',
    value: '7 month',
  },
  {
    id: 10,
    name: '8 Month',
    value: '8 month',
  },
  {
    id: 11,
    name: '9 Month',
    value: '9 month',
  },
  {
    id: 12,
    name: '10 Month',
    value: '10 month',
  },
  {
    id: 13,
    name: '11 Month',
    value: '11 month',
  },
  {
    id: 14,
    name: '12 Month',
    value: '12 month',
  },
];

const TypeAccessDefault = [
  {
    id: 0,
    name: 'Exhibition Only',
    value: 'Exhibition',
  },
  {
    id: 1,
    name: 'Exhibition + Play',
    value: 'Exhibition + Play',
  },
  {
    id: 2,
    name: 'Regular Class',
    value: 'Regular Class',
  },
  {
    id: 3,
    name: 'Special Class',
    value: 'Special Class',
  },
  {
    id: 4,
    name: 'Collaboration',
    value: 'Collaboration',
  },
];

const TypeEventDefault = [
  {
    id: 0,
    name: 'Play / Exhibition Ticket',
    value: 'play',
    desc: 'Tickets for Play and Exhibition',
    class: 'bg-secondary-main text-white border border-secondary-main',
  },
  {
    id: 1,
    name: 'Class Pass',
    value: 'class',
    desc: 'Ticket for KiN classes',
    class: 'bg-[#91C5EB] text-white border border-[#91C5EB]',
  },
];

const menuItems = [
  { name: 'My Profile', submenu: null, url: '/my-profile' },
  { name: 'My Classes', submenu: null, url: '/my-classes' },
  { name: 'My Class Passes', submenu: null, url: '/my-passes' },
  { name: 'My Play & Exhibition Passes', submenu: null, url: '/my-play-exhibition' },
  { name: 'My Participant', submenu: null, url: '/my-participant' },
  {
    name: 'Log Out',
    submenu: null,
    url: '/login',
  },
];

export {
  TimeDefault,
  DurationDefault,
  AgeDefault,
  DifficultyDefault,
  TypeClassDefault,
  SubjectDefault,
  PeriodDefault,
  TypeAccessDefault,
  TypeEventDefault,
  menuItems,
};
